export const TEMPLATE_ID = 'templateId';
export const DEFAULT_LANGUAGE_ID = 1;
export const ADMIN_ROLE = 'FORDESK_TEMPLATES_MGT_ADMIN';

//local storage keys
export const SAVED_TEMPLATE_LANGUAGE_ID = 'savedTemplateLanguageId';
export const SAVED_CATEDORIES_IDS = 'savedCategoriesIds';
export const SAVED_TENANT = 'savedTenant';
